import * as Marionette from "backbone.marionette";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import {transient} from "aurelia-dependency-injection";

const template = require<string>("../../shared/views/thinker.html");

@backboneViewProperties({
    template
})

export class ThinkerView extends Marionette.ItemView<any> {

    constructor(options?) {
        super(options);
    }

    public render() {
        Marionette.ItemView.prototype.render.call(this);
        return this;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/views/thinker.ts